import type { ReactNode } from 'react';
import type { IconProps } from '../../types';

interface IconShellProps extends IconProps {
  children: ReactNode;
}

/**
 * Shared 24×24 stroke-icon shell.
 *
 * Replaces the `lucide-react` dependency the 7.3.x build could not use,
 * since Babel-in-browser had no module resolution. Colour is inherited
 * via `stroke="currentColor"`.
 */
export function Icon({ size = 24, strokeWidth = 2, children }: IconShellProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {children}
    </svg>
  );
}
